<template>
        <div class="px-3">

            <div class="text-body-1 pb-3">
                СМС с кодом было отправленно на номер телефона <b id="hidden-phone">{{phone | tel({mask: true})}}</b>. <a @click="changePhone" class="text-decoration-underline">Изменить</a>
            </div>

            <v-text-field ref="code" v-model="code" label="Код из СМС" :disabled="code.length == 6" autofocus
                autocomplete="one-time-code" type="number" pattern="\d{6}" min="0" :error-messages="errorMessage"
                inputmode="numeric" maxlength="6" :loading="showLoading" />

            <div style="height: 20px" class="mt-2">
                <a v-if="nextEnabled"  @click="resend" class="text-decoration-underline">
                Запросить код повторно
            </a>

            <div v-if="!nextEnabled" class="text-caption grey--text">Запросить код повторно можно через {{time}} сек</div>
            </div>

            <div class="d-flex justify-end mt-3">
                <v-btn depressed color="primary" :loading="showLoading" @click="checkCode">Далее</v-btn>
            </div>
        </div>
</template>

<script>
    export default {
        props: {
            phone: {
                type: String,
                required: true,
                validator: v => /^[0-9]{10}$/.test(v)
            },
            loading: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            nextEnabled() {
                return this.time == 0
            },
            showLoading() {
                return this.loading || this.iternalLoading
            }
        },
        watch: {
            code(val) {
                if (val && val.length == 6) {
                    this.checkCode()
                }
            }
        },
        mounted() {
            this.refreshTimer()
        },
        beforeDestroy() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
        },
        data() {
            return {
                iternalLoading: false,
                time: 0,
                timer: null,
                errorMessage: null,
                code: '',
                codeRules: [
                    v => /^[0-9]{6}$/.test(v) || 'Проверочный код должен состоять из 6 цифр'
                ],
            }
        },

        methods: {

            changePhone() {
                this.$emit('back')
            },

            focus() {
                this.$refs.code.$refs.input.focus()        
            },

            refreshTimer() {
                this.time = 60
                this.startTimer()
            },

            startTimer() {
                this.timer = setTimeout(() => {
                    this.time--
                    if (this.time < 0) {
                        this.time = 0
                    }
                    if (this.time > 0) {
                        this.startTimer()
                    }
                }, 1000)
            },

            validate() {
                return !this.codeRules.some(rule => {

                    let res = rule(this.code)
                    if (res != true) {
                        this.errorMessage = res
                        return true
                    }
                })
            },

            resend() {
                this.refreshTimer()
                this.$emit('resend')
            },

            checkCode() {
                if (!this.validate()) return;

                this.iternalLoading = true

                this.$api.phoneConfirm(this.code)
                    .then(res => {
                        this.$emit('confirmed')
                    })
                    .catch(error => {
                        this.code = ''
                        switch (error.code) {
                            case 10: {
                                this.errorMessage = error.message
                                this.$nextTick(() => {
                                    this.$refs.code.$refs.input.focus()
                                })
                                break;
                            }
                            default: {
                                this.$logger.error('phoneConfirm: ', error)
                                this.$eventBus.$emit('error', error)
                                break;
                            }
                        }
                    })
                    .finally(() => {
                        this.iternalLoading = false
                    })
            },
        }
    }
</script>

<style>

</style>